import React from 'react'
import styles from "./FJKeyword.module.less";
import FJButton from "fj-components/FJButton";

function FJKeyword(props) {
	const {text, onClick} = props;
	return <FJButton text={text}
	                 className={styles.btn_box}
	                 textClass={styles.text_box}
	                 onClick={(e) => {
		                 e.stopPropagation();
		                 onClick(text);
	                 }}
	/>
}

export default FJKeyword;